import { render } from "./HeroiconsSolidHashtag.vue?vue&type=template&id=65c7ca20"
const script = {}

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidHashtag.vue"]])

export default __exports__